import React, { useEffect, useState } from 'react'
import MultiCardForm from './Modals/MultiCardForm'
import { HTTP } from '../../api/resources'

export default function MultiCardList({publicCards, team, newCards, cardFormat, stripeAccounts, records}) {
  const [openModal, setOpenModal] = useState(false)
  const [editing, setEditing] = useState(false)
  const [saving, setSaving] = useState(false)
  const [cards, setCards] = useState(publicCards)
  const [editingPublicCard, setEditingPublicCard] = useState(null)
  const [deletingCardId, setDeletingCardId] = useState(null)

  useEffect(() => {})

  const validateCard = (cardData) => {
      let paymentLink = cardData.payment_redirect_link ? cardData.payment_redirect_link.trim() : ''
  
      if (cardData.use_payments && cardData.payment_method == 'external_payment_method' && paymentLink) {
        if (
          paymentLink.includes("://") ||
          paymentLink.includes(" ")
        ) {
          Alert.show(
            "notice",
            "Payment link cannot include protocol e.g https:// or spaces"
          );
          return false;
        }
      }
  
      if (cardData.use_payments && cardData.payment_method == 'external_payment_method' && (!paymentLink || paymentLink.length < 1)) {
        Alert.show(
          "notice",
          "Payment link cannot be blank when using team payments"
        );
        return false;
      }
  
      if (!cardData.title || cardData.title.length < 1) {
        Alert.show('notice', 'Title cannot be blank');
        return false 
      }
  
      if (cardData.use_payments && cardData.donation_type == 'monthly' && (!cardData.donation_amount || cardData.donation_amount < 2)) {
        Alert.show('notice', 'Donation amount cannot be less than $2')
        return false 
      }

      if (cardData.records.length < 1) {
        Alert.show('notice', 'You must select at lease one profile')
        return false
      }
  
      handleSubmit(cardData)
    }
  
    const handleSubmit = (cardData) => {
      setSaving(true);

      const url = cardData.id && editing 
        ? `/public/cards/multi_card?card_id=${cardData.id}` 
        : `/public/cards/multi_card`;

      HTTP.post(url, { public_card: cardData })
        .then((response) => {
          // Use the functional update (prevCards) to avoid stale data
          setCards((prevCards) => {
            if (cardData.id && editing) {
              // UPDATE LOGIC
              return prevCards.map((card) => 
                card.id === response.data.id ? response.data : card
              );
            } else {
              // CREATE LOGIC
              return [response.data, ...prevCards];
            }
          });

          setEditingPublicCard(null);
          setOpenModal(false);
          Alert.show('notice', `Card ${cardData.id ? 'updated' : 'created'} successfully`);
        })
        .catch((error) => {
          Alert.show('error', 'Operation failed');
        })
        .finally(() => {
          setSaving(false);
        });
    };

    const copyToClipboard = (url) => {
      navigator.clipboard.writeText(url)
      Alert.show('notice', 'Copied public card url to clipboard')
    }

    const handleEdit = (card) => {
      setEditingPublicCard(card)
      setOpenModal(true)
      setEditing(true)
    }

    const handleDelete = async (cardId) => {
      setSaving(true)
    
      HTTP.delete(`/public/cards/multi_card/${cardId}`)
        .then((response) => {
          let updatedCards = cards.filter((card) => card.id !== cardId);
          setCards(updatedCards);
          Alert.show('notice', 'Card deleted successfully');
        })
        .catch((error) => {
          Alert.show('error', 'Failed to delete card');
        })
        .finally(() => {
          setSaving(false);
          setDeletingCardId(null)
        });
    }

  return (
    <div>
      <div className="card">
        <div className="card-header flex-header">
          <h4 className="card-title">
            Public Multi Cards
          </h4>
          <a href="#" className="btn btn-primary" onClick={() => setOpenModal(true)}>+ Add Multi Card</a>
        </div>
      </div>

      {cards &&
        <div className="card">
          <div>
            <div className="list-group list-group-flush">
              {cards.map((card, index) => (
                <div key={card.id} className="list-group-item">
                  <div className='list-group-item-body'>
                    <div className='list-group-item-body-main'>
                      <span>{card.title}</span>
                    </div>
                  </div>
                  <div className='list-group-item-actions'>
                    <div>
                        <button className="btn btn-sm btn-outline-primary mr-2" onClick={() => handleEdit(card)}>
                          <i className="fa fa-pencil"></i> Edit
                        </button>
                        <button 
                          className="btn btn-sm btn-danger mr-2" 
                          onClick={() => {
                            // 1. Ask for confirmation
                            const confirmed = window.confirm("Are you sure? This can't be undone.");
                            
                            // 2. Only run logic if they clicked "OK"
                            if (confirmed) {
                              handleDelete(card.id); 
                              setDeletingCardId(card.id);
                            }
                          }} 
                          disabled={deletingCardId === card.id}
                        >
                          {deletingCardId === card.id && <i className="fa fa-spinner-third fa-spin mr-2"></i>}
                          Delete
                        </button>
                        <button onClick={() => copyToClipboard(card.url)} className="btn btn-sm btn-outline-primary"><i className="fa fa-clipboard"></i></button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
        </div>
        </div>
      }

      {cards.length == 0 &&
        <div className="card-body">
          Let's get started with your first public multi-card :)
        </div>
      }

      {openModal &&
        <MultiCardForm 
          editing={editing}
          newCards={newCards}
          team={team}
          stripeAccounts={stripeAccounts}
          saving={saving}
          onSave={(publicCard) => validateCard(publicCard)}
          onClose={() => {
            setOpenModal(false)
            setEditing(false)
            setEditingPublicCard(null)
          }}
          records={records}
          editingCard={editingPublicCard}
        />
      }
    </div>
  )
}
